import Vue from 'vue'
import api from '../../api/api'

const state = {
  all: []
}

// getters
const getters = {}

// actions
const actions = {
  getAllDistricts ({ commit }) {
    api.getDistricts(districts => {
      commit('setDistricts', districts)
    })
  }
}
const mutations = {
  updateDistrict (state, options) {
    Vue.set(state.all, options.index, options.item)
  },
  setDistricts (state, districts) {
    state.all = districts
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/districts.js